import Users from 'modules/users/Users'
import React from 'react'

export default function UserProfile() {
  return (<Users />)
}
